import { getDatoContent } from '@services/bff-content-hub/datocms/getDatoContent';
import { DATO_CONTENT_TYPE } from '@services/bff-content-hub/datocms/getDatoContent.constants';

const VALID_STATUS = [200];

export type THeaderLinkConfig = {
  titleMobile?: string;
  titleDesktop: string;
  phoneNumber: string;
  icon: string;
  activeMobile: boolean;
  active: boolean;
  link: Record<string, any>;
};

export type TClientMenu = {
  orders: boolean;
  services: boolean;
  attendence: boolean;
  wallet: boolean;
  adresses: boolean;
  information: boolean;
  privacy: boolean;
  favorite: boolean;
  logout: boolean;
};

type THeaderConfig = {
  clientMenu?: TClientMenu;
  salesChannels?: THeaderLinkConfig[];
  clientChannels?: THeaderLinkConfig[];
  menuDesktopChannels?: THeaderLinkConfig[];
  menuMobileChannels?: THeaderLinkConfig[];
  textMobile?: string;
};

const getClientMenu = ({
  orders,
  services,
  attendence,
  wallet,
  adresses,
  information,
  privacy,
  favorite,
  logout,
}) => ({
  orders,
  services,
  attendence,
  wallet,
  adresses,
  information,
  privacy,
  favorite,
  logout,
});

export async function getHeaderConfig(): Promise<THeaderConfig> {
  const { headerConfig } = await getDatoContent({
    modelApiKey: 'header_config',
    type: DATO_CONTENT_TYPE.SINGLETON,
    id: 'data',
  });

  const {
    salesChannels = [],
    clientChannels = [],
    menuDesktopChannels = [],
    menuMobileChannels = [],
    textMobile,
  } = headerConfig;

  const parsedClientMenu = getClientMenu(headerConfig);

  return {
    clientChannels,
    salesChannels,
    menuDesktopChannels,
    menuMobileChannels,
    clientMenu: parsedClientMenu,
    textMobile,
  };
}
